export default function fetchWrapper(url, options = {}) {
  options.headers = { ...options.headers, "X-Requested-With": "XMLHttpRequest" }

  return fetch(url, options)
}
